/* eslint-disable no-fallthrough */
/* eslint-disable import/no-named-as-default */
import WizardPageLayout from "component-lib/WizardPageLayout";
import LoadingIndicator from "components/LoadingIndicator";
import _ from "lodash";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { bindActionCreators, compose } from "redux";

import { dealGet } from "../../../deal/deal.store";
import { actionCreators as baseActionCreators } from "../../reportingSetup/reportingSetup.store";

import { actionCreators as noiActionCreators } from "./noiSetup.store";
import Step1 from "./step1";
import { BackButton, Card, Container } from "./styles";

const LenderReportsNoiSetup = props => {
  const {
    deal,
    getReportConfig,
    history,
    isLoading,
    match: {
      params: { dealId, reportId }
    },
    reportConfig,
    setSelections,
    user: { id: userId },
    wizardStep,
    wizardStepDecrement
  } = props;

  const properties = [];

  if (!_.isEmpty(deal) && deal.properties) {
    // Filter active properties on the deal
    properties.push(deal.properties.filter(property => !property.actualExitDate));
  }

  useEffect(() => {
    if (_.isEmpty(deal)) {
      props.dealGet({ dealId });
    }
  }, [dealId, deal]);

  useEffect(() => {
    setSelections({ currentUserId: userId, selectedDealId: dealId, selectedReportId: reportId });

    if (_.isEmpty(reportConfig) || _.isEmpty(reportConfig.reportName)) {
      getReportConfig({ id: reportId });
    }
  }, [reportId]);

  // Grouping
  const step1 = () => <Step1 {...props} />;

  const wizard = () => {
    switch (wizardStep) {
      case 1:
        if (properties.length) {
          return step1();
        }
      default:
        if (wizardStep > 0) {
          wizardStepDecrement();
        }

        // TODO: Where do you go back from here?
        return <BackButton id="back-button" label="Back" iconName="arrow_forward" reverse alignRight={false} key={1} onClick={() => history.goBack()} />;
    }
  };

  return (
    <WizardPageLayout
      cardComponent={
        <Container>
          <Card>{!isLoading && deal && reportConfig ? wizard() : <LoadingIndicator loading />}</Card>
        </Container>
      }
    />
  );
};

const mapStateToProps = ({
  lenderReportingSetup: { reportConfig, isLoading, selectedDealId, selectedReportId, currentUserId },
  lenderReportsNoiSetup,
  newDeal: { deal },
  authentication: { user }
}) => ({
  reportConfig,
  isLoading,
  selectedDealId,
  selectedReportId,
  currentUserId,
  ...lenderReportsNoiSetup,
  deal,
  user
});

const mapDispatchToProps = dispatch => bindActionCreators({ ...baseActionCreators, ...noiActionCreators, dealGet }, dispatch);

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(LenderReportsNoiSetup);
